module.exports = __webpack_public_path__ + "static/media/openCollapse.5e71de17.svg";